import type { BrowserDataState } from './types';

const getPriceProviderData = (state: BrowserDataState) =>
  state.priceProviderData;

const getBaseUrl = (state: BrowserDataState) => state.baseUrl;

const isInitialLoad = (state: BrowserDataState) => state.initialLoad;

const isRequestFailureState = (state: BrowserDataState) => state.failed;

const getPriceSourceId = (state: BrowserDataState) => state.priceSourceId;

const getViewId = (state: BrowserDataState) => state.viewId;

const getJhaToken = (state: BrowserDataState) => state.jhaToken;

export default {
  getPriceProviderData,
  getBaseUrl,
  isInitialLoad,
  isRequestFailureState,
  getPriceSourceId,
  getViewId,
  getJhaToken,
};
